module.exports = __webpack_public_path__ + "static/media/inktoberCat.3e02a2f7.gif";